import axios from "axios";

let url1 = "https://admin.techqilla.com/api/";

const axiosApi = axios.create({
  baseURL: url1,
});

export { axiosApi };
